import { IconButton, Text, HStack } from '@genial/components';
import React from 'react';

export namespace PrivatePensionModalHeaderTypes {
  export type Props = {
    title: string;
    onClose: () => void;
  };
}

export const PrivatePensionModalHeader: React.FC<PrivatePensionModalHeaderTypes.Props> = ({
  title,
  onClose,
}) => {
  return (
    <HStack justifyContent="space-between" alignItems="center">
      <Text variant="semibold" fontSize="lg">
        {title}
      </Text>
      <IconButton
        onPress={onClose}
        icon="CloseModal"
        iconColor="neutral.black"
        iconSize="sm"
        testId="icon-close-private-pension-portability-modal-header"
        padding="0"
      />
    </HStack>
  );
};
